import { useMemo } from "react";
import {
  GetCallAiActionsQuery,
  GetCallAiActionsQueryVariables,
} from "@/graphql/generated/graphql";
import { GetCallAIActions } from "@/graphql/queries/GetCallAIActions";
import { mapToAIActionItems } from "@/helpers/aiActions/aiActions.helpers";
import { AIActionItem } from "@/helpers/aiActions/aiActions.helpers.decl";
import { useCall } from "@/hooks/useCall/useCall";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";

/**
 * AI Actions the call's virtual agent ran, positioned in seconds from the call start
 * so they can be interleaved with the transcript utterances.
 */
export function useCallAIActions(): AIActionItem[] {
  const { call } = useCall();
  const { data } = useQueryWrapper<
    GetCallAiActionsQuery,
    GetCallAiActionsQueryVariables
  >(GetCallAIActions, {
    skip: !call?.uuid,
    variables: { callSid: call?.uuid ?? "" },
  });

  return useMemo(() => {
    if (!call?.uuid) {
      return [];
    }
    return mapToAIActionItems(
      data?.getCallTimelineByCallSidV2,
      call.answeredAt ?? call.createdAt
    );
  }, [call, data]);
}
